<script>
//全局路径
const globalPath = {};
let path;


//获取各打包环境地址，并拼接
if (process.env.NODE_ENV === "development") {
    // dev
    path = {
        // api : "/api/", 
        sdkEvn : 'pro',
        url : '/url/',
        IgwIam:'/IgwIam/',
        IgwIoa:'/IgwIoa/',
        IgwSso:'/IgwSso/',
        IfeOcr:'/IfeOcr/',
        IfeOss:"/IfeOss/",
        IgwSvc:'/IgwSvc/',
        Sso:"/Sso/",
        IgwIar:"/IgwIar/",
        platformUrl :'http://192.168.110.65:8033'
    }
} else {
    path = {
        // api : process.env.API_ROOT + "api/", 
        sdkEvn : 'pro',
        url : process.env.API_ROOT,
        IgwIam : process.env.API_ROOT + 'igw/iam/',
        IgwIoa : process.env.API_ROOT + 'igw/ioa/api/',
        IgwSso : process.env.API_ROOT + 'igw/sso/',
        IfeOcr : process.env.API_ROOT + 'igw/ife/ocr/',
        IfeOss : process.env.API_ROOT + 'igw/ife/oss/',
        IgwSvc : process.env.API_ROOT + 'igw/svc/',
        Sso : process.env.API_ROOT + 'sso/',
        IgwIar : process.env.API_ROOT + 'igw/iar/',
        platformUrl : process.env.PLATFORM_URL
    }
    console.log('process.env.NODE_ENV：'+ process.env.NODE_ENV)
}

console.log(path)
Object.assign(globalPath, path);

export default {
    globalPath
};
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue